import { useState } from "react";
import { getInitials } from "../data/avatars";

export function OndaAvatar({ src, name, size = 48, className = "", testId }) {
  const [failed, setFailed] = useState(false);
  const showFallback = !src || failed;
  const initials = getInitials(name);

  const style = { width: size, height: size };

  if (showFallback) {
    return (
      <div
        data-testid={testId}
        className={
          "flex items-center justify-center rounded-2xl font-display font-bold text-white " +
          "bg-gradient-to-br from-slate-700 to-slate-900 border border-white/10 " +
          className
        }
        style={{ ...style, fontSize: size * 0.36 }}
      >
        {initials}
      </div>
    );
  }

  return (
    <img
      data-testid={testId}
      src={src}
      alt={name || "avatar"}
      onError={() => setFailed(true)}
      style={style}
      className={"rounded-2xl object-cover border border-white/10 " + className}
    />
  );
}
